var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"training-batch-setting"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-cont"},[_c('TrainingBatchSettingMain',{attrs:{"batch-id":_vm.batchId}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("训练通用设置")])])
}]

export { render, staticRenderFns }